// extracted by mini-css-extract-plugin
export var button = "_19-0";
export var buttonContent = "_19-e";
export var buttonGroup = "_19-c";
export var dontRestrainIconWidth = "_19-a";
export var dropdownButton = "_19-b";
export var iconContainer = "_19-9";
export var lg = "_19-4";
export var md = "_19-3";
export var pending = "_19-f";
export var sm = "_19-2";
export var spinner = "_19-d";
export var squared = "_19-8";
export var wrapText = "_19-g";
export var xl = "_19-5";
export var xs = "_19-1";
export var xxl = "_19-6";
export var xxxl = "_19-7";